module.exports = __webpack_public_path__ + "54ff02a3a008e0c6f24472f788e83bfd.svg";